import { Button, Dropdown, Icon, Menu } from '@alifd/next';
import { ButtonProps } from '@alifd/next/types/button';
import { SubMenuProps } from '@alifd/next/types/menu';
import { useEffect, useState } from 'react';
import { MixIcon } from '../MixIcon';
import './index.scss';

interface DropdownButtonMenuItemProps extends SubMenuProps {
    id?: string;
    icon?: string;
    color?: string;
    bgColor?: string;
    disabled?: boolean;
}
export interface DropdownButtonProps extends Omit<ButtonProps, 'onClick' | 'onMouseUp'> {
    id?: string;
    content?: string;
    icon?: string;
    // Dropdown相关属性
    /**
     * 弹层当前是否显示
     */
    visible?: boolean;
    /**
     * 触发弹层显示或隐藏的操作类型，可以是 'click'，'hover'，或者它们组成的数组，如 ['hover', 'click']
     */
    popupTriggerType?: 'click' | 'hover' | Array<'click' | 'hover'>;
    /**
     * 弹层显示或隐藏时触发的回调函数
     */
    visibleChange?: (args: any) => void;
    __onVisibleChange?: (visible: boolean) => void;
    /**
     * 是否跟随trigger滚动
     */
    followTrigger?: boolean;
    autoWidth?: boolean;
    //菜单
    items?: DropdownButtonMenuItemProps[];
    itemClick?: (args: any) => void;
}

export const DropdownButton: React.FC<DropdownButtonProps> = (props) => {
    const { id, content, icon, visible, popupTriggerType, visibleChange, __onVisibleChange, followTrigger, autoWidth, items, itemClick, children, ...otherProps } = props;
    const [_visible, setVisible] = useState<boolean>();
    const [width, setWidth] = useState<number>();
    const itemHasIcon = (items ?? []).filter((v) => !!v.icon).length > 0;
    const iconSize = props.iconSize == null ? (props.size === 'large' ? 'small' : 'xs') : props.iconSize;

    const btnRefHandler = (ref: any) => {
        if (!ref) return;
        const instance = ref.getInstance();
        if (instance && instance.button && width !== instance.button.offsetWidth) {
            setWidth(instance.button.offsetWidth);
        }
    };
    const onVisibleChange = (visible: boolean, type: string | object, e?: object) => {
        setVisible(visible);
        __onVisibleChange?.(visible);
        visibleChange?.({ visible, type, e });
    };
    const onItemClick = (key: string, item: any, event: React.MouseEvent | React.KeyboardEvent) => {
        itemClick?.({ id: key, item, e: event });
    };

    useEffect(() => {
        setVisible(visible);
    }, [visible]);
    return (
        <Dropdown visible={_visible} triggerType={popupTriggerType} followTrigger={followTrigger} onVisibleChange={onVisibleChange}
            trigger={<Button ref={btnRefHandler} style={props.style} className={(!content && icon) ? 's-only-icon' : undefined} {...otherProps}>
                {icon && (icon.indexOf(':') === -1 ? <Icon type={icon} /> : <MixIcon value={icon} size={iconSize} color={props.style?.color} />)}{content}
            </Button>}>
            <Menu className='custom-menu' onItemClick={onItemClick} style={{ width: (autoWidth ? `${width}px` : undefined) }}>
                {items && items.map(({ children: itemChildren, icon: itemIcon, color, bgColor, ...item }) =>
                    <Menu.Item {...item} key={item.id} disabled={props.disabled || item.disabled}
                        style={{ color: color, backgroundColor: bgColor }}>
                        <div className="s-dropdown-item">
                            {itemIcon && (itemIcon.indexOf(':') === -1 ? <Icon type={itemIcon} size='xs' /> : <MixIcon value={itemIcon} size='xs' />)}
                            {itemHasIcon && !itemIcon && <i className="next-icon next-xs" style={{ width: '12px' }}></i>}
                            <span className="s-dropdown-item-title">{itemChildren}</span>
                        </div>
                    </Menu.Item>
                )}
            </Menu>
        </Dropdown>
    );
};